import React from "react";
import UtilsFormule from "../../utils/UtilsFormule";

const PERIODS = {
  Jour: { key: "caByDate", date: () => UtilsFormule.formatDate(new Date()) },
  Semaine: { key: "caByWeek", date: () => UtilsFormule.formatDateWeek(new Date()) },
  Mois: { key: "caByMonth", date: () => UtilsFormule.formatDateMonth(new Date()) },
  Année: { key: "caByYear", date: () => UtilsFormule.formatDateYear(new Date()) },
};

const toNumber = (value) => {
  const n = Number(value);
  return value == null || isNaN(n) ? null : n;
};

// Supprime les .000 inutiles (3 décimales maximum)
const formatNumber = (value) => {
  const n = toNumber(value);
  if (n === null) return "-";
  return parseFloat(n.toFixed(3)).toLocaleString("fr-FR", {
    maximumFractionDigits: 3,
  });
};

const CardMagasinhome = ({ shopList, card }) => {
  return (
    <>
      {shopList &&
        shopList.map((shopItem, shopIndex) => (
          <div
            className="card mb-3"
            key={shopItem?.refShop || shopItem?.nameShop || shopIndex}
            style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}
          >
            <div className="card-header d-flex align-items-center">
              <span
                className="d-flex align-items-center justify-content-center bg-dark text-white mr-3"
                style={{ width: 38, height: 38, borderRadius: 8 }}
              >
                <i className="fas fa-store"></i>
              </span>
              <div>
                <h5 className="mb-0" style={{ fontWeight: 600 }}>
                  {shopItem?.nameShop}
                </h5>
                {shopItem?.refShop && (
                  <small className="text-muted">{shopItem?.refShop}</small>
                )}
              </div>
            </div>
            <div className="card-body pb-1">
              <div className="row">
                {card &&
                  card.map((item, index) => {
                    const period = PERIODS[item?.by];
                    const data = period ? shopItem?.[period.key] : null;
                    const somme = toNumber(data?.somme);
                    const achat = toNumber(data?.achat);
                    const profit =
                      somme !== null && achat !== null ? somme - achat : null;
                    const margin =
                      profit !== null && somme ? (profit / somme) * 100 : null;
                    const positive = profit === null || profit >= 0;
                    return (
                      <div className="col-xl-3 col-md-6 col-12 mb-3" key={index}>
                        <div
                          className="h-100 p-3"
                          style={{
                            border: "1px solid #e9ecef",
                            borderLeft: "4px solid #343a40",
                            borderRadius: 8,
                            background: "#fff",
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <div>
                              <span className="badge badge-dark">{item?.by}</span>
                              <small className="text-muted d-block mt-1">
                                {period ? period.date() : ""}
                              </small>
                            </div>
                            <span
                              className="d-flex align-items-center justify-content-center bg-dark text-white"
                              style={{ width: 34, height: 34, borderRadius: 8 }}
                            >
                              <i className={item?.icon}></i>
                            </span>
                          </div>

                          <small
                            className="text-muted text-uppercase d-block"
                            style={{ fontWeight: 600, letterSpacing: "0.03em" }}
                          >
                            {item?.titre}
                          </small>
                          <div style={{ fontSize: "1.5rem", fontWeight: 700 }}>
                            {formatNumber(data?.somme)}
                          </div>

                          <hr className="my-2" />
                          <div className="d-flex justify-content-between">
                            <small className="text-muted">Achat</small>
                            <strong>{formatNumber(data?.achat)}</strong>
                          </div>
                          <div className="d-flex justify-content-between align-items-center">
                            <small className="text-muted">Bénéfice brut</small>
                            <span>
                              <strong
                                style={{ color: positive ? "#28a745" : "#dc3545" }}
                              >
                                {profit === null ? "-" : formatNumber(profit)}
                              </strong>
                              {margin !== null && (
                                <span
                                  className={`badge ml-1 ${
                                    positive ? "badge-success" : "badge-danger"
                                  }`}
                                >
                                  {margin.toFixed(1)}%
                                </span>
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        ))}
    </>
  );
};
export default CardMagasinhome;
